import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchAssets } from "../../services";
import { TAppAsset } from "../../types/asset";
import { Asset } from "../../types/newTypes/Asset";

interface AssetsState {
  data: TAppAsset[];
  selected: TAppAsset | null;
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}

const initialState: AssetsState = {
  data: [],
  selected: null,
  status: "idle",
  error: null,
};

// Define the async thunk action
export const getAssets = createAsyncThunk(
  "assets/getAssets",
  async ({ assets }: { assets: Asset[] }) => {
    return await fetchAssets(assets);
  }
);

const assetsSlice = createSlice({
  name: "assets",
  initialState,
  reducers: {
    selectAsset: (state, action: PayloadAction<String>) => {
      if (action.payload === "") {
        state.selected = null;
      } else {
        const [symbol, chain, contract] = action.payload.split("-");
        state.selected = state.data.find((asset) => {
          let found = asset.symbol.toUpperCase() === symbol;
          if (chain) {
            found = found && asset.layer2data?.chain.toLowerCase() === chain.toLowerCase();
          }
          if (contract) {
            found =
              found && asset.layer2data?.contractAddress.toLowerCase() === contract.toLowerCase();
          }
          return found;
        });
      }
    },
    clearSelection: (state) => {
      state.selected = null;
    },
    resetAssetsState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAssets.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAssets.fulfilled, (state, action: PayloadAction<any>) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(getAssets.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "Something went wrong";
      });
  },
});

export const { selectAsset, clearSelection, resetAssetsState } = assetsSlice.actions;
export default assetsSlice.reducer;
